export default __webpack_public_path__ + "static/media/team116.5627dcc1.JPG";